var treat = {
	wrapperEl: $('.treat, .module-treat-new'),
	openEl: $('.treat-trigger'),
	closeEl: $('.treat-close'),

	isVisible: function (element, fullyInView) {
    var pageTop = $(window).scrollTop();
    var pageBottom = pageTop + $(window).height();
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).height();

    if (fullyInView === true) {
        return ((pageTop < elementTop) && (pageBottom > elementBottom));
    } else {
        return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
    }
  },

	toggleCode: function() {
		var triggers = treat.openEl.add(treat.closeEl);

		triggers.click(function(e){
			e.preventDefault();

			$(this).closest(treat.wrapperEl).toggleClass('active');
		});
	},

	toggleFixedCode: function () {
		if (treat.isVisible($('.module-barcode .barcode'), true)) {
			$('body').removeClass('module-barcode-visible');
		} else {
			$('body').addClass('module-barcode-visible');
		}
	},

	init: function() {
		if (treat.wrapperEl.length) {
			treat.toggleCode();
			
			$(window).scroll(treat.toggleFixedCode)
				.resize(treat.toggleFixedCode)
				.trigger('resize');
			
			$('.module-title-description.small-screen').ellipsis({
				lines: 3,
				ellipClass: 'ellip',
				responsive: true
			});

			$('.module-title-readmore').on('click', function () {
				$(this).parent().find('.module-title-description.small-screen').addClass('hidden');
				$(this).parent().find('.module-title-description.large-screen').addClass('visible');
				$(this).hide();
			});
		}

		$('.searchDd-category > a').on('click', function (e) {
			var $el = $(this);
			var filterCategoryId = $el.data('categoryId');
			
			if (filterCategoryId) {
				$('.module-treat-new').each(function (index, item) {
					var $item = $(item);
					var treatCategoryId = $item.data('categoryId');
					if (filterCategoryId == treatCategoryId) {
						$item.parent().show();
					} else {
						$item.parent().hide();
					}
				});
			} else {
				$('.module-treat-new').parent().show();
			}
			
			var $main = $el.closest('.treat-filter').find('.searchDd-main');
			var $list = $el.closest('.treat-filter').find('.searchDd-list');

			$list.find('li > a').removeClass('selected');

			if (filterCategoryId) {
				$main.find('.searchDd-main-default').hide();
				$main.find('.searchDd-main-selected').html($el.html()).show();
				$list.find('.clear-filter').show();
				$el.addClass('selected');
			} else {
				$main.find('.searchDd-main-selected').hide();
				$main.find('.searchDd-main-default').show();
				$list.find('.clear-filter').hide();
			}
			
			$main.removeClass('open');
			$list.removeClass('open');
		});
	}
};